import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'motion/react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { PageSkeleton } from '@/components/ui/skeleton';
import { useApp } from '@/store';

export function AppLayout() {
  const loc = useLocation();
  const hydrated = useApp(s => s.hydrated);
  // Superadmin pages read from the REST API (not the per-tenant PouchDB), so
  // they manage their own loading and must not wait on store hydration.
  const isSuperadmin = loc.pathname.startsWith('/superadmin');
  const showSkeleton = !hydrated && !isSuperadmin;
  return (
    <div className="flex min-h-screen bg-gradient-to-br from-background via-background to-muted/30 text-foreground">
      <Sidebar />
      <div className="flex flex-1 flex-col min-w-0">
        <Header />
        <main className="flex-1 overflow-auto p-3 sm:p-4 md:p-6">
          <AnimatePresence mode="wait">
            <motion.div
              key={loc.pathname}
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -4 }}
              transition={{ duration: 0.2, ease: 'easeOut' }}
            >
              {showSkeleton ? <PageSkeleton /> : <Outlet />}
            </motion.div>
          </AnimatePresence>
        </main>
      </div>
    </div>
  );
}
